export const COMPANY_PROFILE_PERMISSIONS = [
  {
    profileName: "General Permissions",
    profileSlug: "general_permissions",
    permissions: [
      {
        module: "Templates",
        label: "Templates",
        actions: ["View"],
      },
      {
        module: "Documents",
        label: "Documents",
        actions: ["View", "Create and Edit", "Delete", "Share", "Change Owner", "Download", "Publish and Email"],
      },
    ],
  },
  {
    profileName: "Admin Permissions",
    profileSlug: "admin_permissions",
    permissions: [
      { module: "company_settings" },
      { module: "general" },
      { module: "company_details", label: "Manage Company Details" },
      // { module: "Manage_Custom_Merge_Fields", label: "Manage Custom Merge Fields" },
      // { module: "Manage_Integrations", label: "Manage Integrations" },
      { module: "brand_and_appearance" },
      { module: "custom_fonts", label: "Manage Custom Fonts" },
      { module: "brands", label: "Manage Brands" },
      { module: "docHipo_badge", label: "Manage DocHipo Badge" },
      // { module: "Manage_Proposal_Settings", label: "Manage Proposal Settings" },
      { module: "Transfer_Documents", label: "Transfer Documents" },
      { module: "Manage_Company_Templates", label: "Manage Company Templates" },
    ],
  },
  {
    profileName: "Super Admin Permissions",
    profileSlug: "super_admin_permissions",
    permissions: [
      { module: "general" },

      // { module: "company_details", label: "Manage Company Details" },
      { module: "delete_company", label: "Delete Company" },
      { module: "users_and_permission", label: "Manage Users and Permissions" },
      { module: "users" },
      { module: "profiles" },
      { module: "billing", label: "Manage Billing" },
      { module: "billing_plan" },
      { module: "invoices" },
    ],
  },
];

Manage_Users_and_Permissions:true

export const COMPANY_PROFILES = [
  {
    name: "Super Admin",
    description: "This profile has all permissions",
    slug: "super_admin",
    id: "653b92cc290658c228790b62",
  },
  {
    name: "Admin",
    slug: "admin",
    id: "676918c2a968278e52e825cb",
    description: "This profile has all permissions except super admin permissions",
    modified_on: 1692360616,
  },
  {
    name: "Standard",
    slug: "standard",
    id: "653b92cc290658c228790b63",
    description: "This profile has all permissions except admin permissions",
    modified_on: 1692360616,
  },
];

export const COMPANY_PROFILES_STORAGE_KEY = "dhp.company.profiles";
